<template>
  <div ref="entity-switcher" class="d-flex flex-wrap gap-3" v-if="localStorage">
    <div v-for="(conf, i) in config" :key="i" v-if="entities[i]">
      <el-switch
        class="pb-3"
        v-if="options.entityPickerEditable"
        v-model="entities[i].active"
        :active-color="calculatColor(conf)"
        :active-text="$i18n.t(conf.alias || conf.formName)"
      ></el-switch>
      <div v-else-if="entities[i].active" class="d-flex align-items-center pb-3">
        <span :style="'color:' + calculatColor(conf)" class="material-icons">circle</span
        >{{ $i18n.t(conf.alias || conf.formName) }}
      </div>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash'

/**
 * @class FullCalendarEntitySwitcher
 *
 * @description This is an entity manager for the FullCalendar interface
 */
export default {
  name: 'full-calendar-entity-switcher',
  props: {
    config: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    panelId: String,
  },
  data() {
    return {
      entities: [],
      localStorage: null,
      storageKey: `calendar-${window.location.pathname}-${this.panelId}`,
    }
  },
  methods: {
    calculatColor(conf) {
      return get(conf, 'styleOptions.color') || '#3a87ad'
    },
    getLocalStorage() {
      try {
        this.localStorage = JSON.parse(window.localStorage.getItem(this.storageKey))
      } catch (error) {
        console.error('error parsing localStorage', error)
      }
    },
    setLocalStorage(type) {
      const result = []
      this.config.forEach((x, i) => {
        result.push({
          index: i,
          active: type === 'init' ? true : get(this, `entities[${i}].active`, true),
        })
      })

      window.localStorage.setItem(this.storageKey, JSON.stringify(result))
      this.localStorage = result
      this.$emit('entities', result)
    },
    initEntities() {
      this.localStorage.forEach((item) => {
        this.entities.push(item)
      })
    },
  },
  watch: {
    config: {
      handler: function (newValue) {
        if (newValue && newValue.length) {
          this.setLocalStorage()
          this.initEntities()
        }
      },
    },
    entities: {
      deep: true,
      handler: function (newValue) {
        this.setLocalStorage()
      },
    },
  },
  mounted() {
    this.getLocalStorage()
    if (!this.localStorage) {
      this.setLocalStorage('init')
    }
    this.initEntities()
  },
}
</script>

<style lang="scss"></style>
